module.exports = __webpack_public_path__ + "static/media/sign.60014ebf.jpeg";